<template>
    <CardBase>
        <div class="text-center mt-4">
            <div class="uppercase text-gray-600">{{ $t('component.lastbookings.title') }}</div>
            <div class="inline-block rounded-full bg-green-600 text-white text-xs px-4 py-1 mt-1">{{totalBookings}}</div>
        </div>
        <div class="mt-6 mb-6 flex justify-between">
            <div class="flex content-center flex-wrap" @click="prevBookings">
                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                     overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="21" height="19">
                    <g>
                        <path xmlns:default="http://www.w3.org/2000/svg"
                              d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
                              style="fill: rgba(18, 18, 18, 0.99);" vector-effect="non-scaling-stroke"/>
                    </g>
                </svg>
            </div>
            <div v-for="(lastBooking, index) in lastBookings" :key="index"
                 :class="slideCss"
                 class="flex text-center border shadow w-20 h-20 hyphens-auto flex-col justify-center items-center text-xs">
                <div>{{formatDate(lastBooking.date)}}</div>
                <div class="uppercase">{{formatLocation(lastBooking.location)}}</div>
                <div>{{lastBooking.salary | formatCurrencyEuro}}</div>
            </div>
            <div class="flex content-center flex-wrap" @click="nextBookings">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.2"
                     overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="21" height="19">
                    <g>
                        <path xmlns:default="http://www.w3.org/2000/svg"
                              d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" style="fill: rgba(18, 18, 18, 0.99);"
                              vector-effect="non-scaling-stroke"/>
                    </g>
                </svg>
            </div>
        </div>
    </CardBase>
</template>

<script>
    import CardBase from "@/components/shared/CardBase";
    import MissionService from "../../services/mission.service";
    import moment from 'moment';

    export default {
        name: "LastBookings",
        components: {
            CardBase
        },
        data() {
            return {
                page: 0,
                pageSize: 3,
                lastBookings: [],
                totalBookings: 0,
                slideRight: false,
                slideLeft: false,
            }
        },
        computed: {
            maxPageSize() {
                return Math.ceil(this.totalBookings / this.pageSize) - 1;
            },
            slideCss() {
                return {
                    'slide-in-right': this.slideRight,
                    'slide-in-left': this.slideLeft
                }
            }
        },
        mounted() {
            this.getLastBookings();
        },
        methods: {
            getLastBookings(animationDirection) {
                MissionService.lastBookings(this.page, this.pageSize).then((response) => {
                    this.lastBookings = response.data.bookings;
                    this.totalBookings = response.data.total;
                    if (animationDirection === 'right') {
                        this.slideRight = true;
                    } else if (animationDirection === 'left') {
                        this.slideLeft = true;
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.slideLeft = false;
                        this.slideRight = false;
                    }, 1000);
                });
            },
            nextBookings() {
                if (this.page < this.maxPageSize) {
                    this.page = this.page + 1;
                } else {
                    this.page = 0;
                }
                this.slideLeft = false;
                this.getLastBookings('left');
            },
            prevBookings() {
                if (this.page > 0) {
                    this.page = this.page - 1;
                } else {
                    this.page = this.maxPageSize;
                }
                this.slideRight = false;
                this.getLastBookings('right');
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('DD.MM');
                }
            },
            formatLocation(value) {
                if (value) {
                    if (value.length > 10) {
                        return value.substring(0, 9) + '...';
                    }
                    return value;
                }
            }
        }
    }
</script>

<style scoped>
    .slide-in-left {
        animation-name: slide-left;
        animation-duration: 1s;
    }

    .slide-in-right {
        animation-name: slide-right;
        animation-duration: 1s;
    }

    @keyframes slide-left {
        0% {
            margin-left: 1rem;
            opacity: 0;
        }
        100% {
            margin-left: 0;
            opacity: 1;
        }
    }

    @keyframes slide-right {
        0% {
            margin-right: 1rem;
            opacity: 0;
        }
        100% {
            margin-right: 0;
            opacity: 1;
        }
    }
</style>